import React, { useEffect, useState } from 'react'

import { Layout, Menu, MenuProps, Space } from 'antd'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Calendar from '../../assets/Images/Calendar.svg'
import AnalyticsIcon from '../../assets/Images/AnalyticsIcon.svg'
import Newspaper from '../../assets/Images/Newspaper.svg'
import Location from '../../assets/Images/MapPinLine.svg'
import Inventory from '../../assets/Images/Inventory.svg'
import Bookmark from '../../assets/Images/Bookmark.svg'
import buildings_svg from '../../assets/Images/Buildings.svg'
import userPlus_svg from '../../assets/Images/UserPlus.svg'
import medal_svg from '../../assets/Images/Medal.svg'
import user_svg from '../../assets/Images/3 User.svg'
import sessionIcon_svg from '../../assets/Images/SessionIcon.svg'
import Jobs_svg from '../../assets/Images/jobs.svg'
import work_svg from '../../assets/Images/Work.svg'
import dashboardIcon from '../../assets/Images/dashboardIcon.svg'
import activityIcon from 'assets/Images/activityIcon.svg'
import { PieChartOutlined, SettingOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { getMe } from 'api/Organizations'
import Loader from 'helper/Loader'

const { Sider } = Layout
type MenuItem = Required<MenuProps>['items'][number]
function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return { key, icon, children, label } as MenuItem
}
const getMenuItems = (data?: any): MenuItem[] =>
  [
    getItem(
      <Link to="/dashboard">
        <Space size={5}>
          <h5 className="b3">Overview</h5>
        </Space>
      </Link>,
      'dashboard',
      <img src={dashboardIcon} />,
    ),
    getItem(
      <Link to="/analytics">
        <Space size={5}>
          <h5 className="b3">Analytics</h5>
        </Space>
      </Link>,
      'analytics',
      <img src={AnalyticsIcon} alt="analytics" />,
    ),

    data?.role === 'admin'
      ? getItem(
          <Link to="/settings?tab=GeneralSetting">
            <Space size={15}>
              <h5 className="b3">Settings</h5>
            </Space>
          </Link>,
          'settings',
          <SettingOutlined className="text-black" size={20} />,
        )
      : null,

    getItem('PEOPLE', 'people', null, [
      getItem(
        <Link to="/organization?page=1&limit=10&status=approved">
          <Space size={15}>
            <h5 className="b3">Organizations</h5>
          </Space>
        </Link>,
        'organization',
        <img src={buildings_svg} alt="organization" />,
      ),
      getItem(
        <Link to="/organizer?page=1&limit=10&status=active">
          <Space size={18}>
            <h5 className="b3">Organizer</h5>
          </Space>
        </Link>,
        'organizer',
        <img src={userPlus_svg} alt="organizer" />,
      ),
      getItem(
        <Link to="/teams">
          <Space size={18}>
            <h5 className="b3">Teams</h5>
          </Space>
        </Link>,
        'teams',
        <img src={userPlus_svg} alt="teams" />,
      ),
      getItem(
        <Link to="/mentors">
          <Space size={14}>
            <h5 className="b3">Mentors</h5>
          </Space>
        </Link>,
        'mentors',
        <img src={medal_svg} alt="mentors" />,
      ),
      getItem(
        <Link to="/family">
          <Space size={8}>
            <h5 className="b3">Families</h5>
          </Space>
        </Link>,
        'family',
        <img src={user_svg} alt="family" />,
      ),
    ]),

    getItem('EVENTS', 'eventsGroup', null, [
      getItem(
        <Link to="/spaces?page=1&limit=10">
          <Space size={18}>
            <h5 className="b3">Spaces</h5>
          </Space>
        </Link>,
        'events',
        <img src={Calendar} alt="events" />,
      ),
      data?.role === 'admin'
        ? getItem(
            <Link to="/jobrequest">
              <Space>
                <h5 className="b3">Request</h5>
              </Space>
            </Link>,
            'jobrequest',
            <img src={work_svg} alt="job request" />,
          )
        : null,
      data?.role === 'admin'
        ? getItem(
            <Link to="/sessions">
              <Space>
                <h5 className="b3">Sessions</h5>
              </Space>
            </Link>,
            'sessions',
            <img src={sessionIcon_svg} alt="sessions" />,
          )
        : null,
      data?.role === 'admin'
        ? getItem(
            <Link to="/jobs">
              <Space>
                <h5 className="b3">Jobs</h5>
              </Space>
            </Link>,
            'jobs',
            <img src={Jobs_svg} alt="jobs" />,
          )
        : null,
      getItem(
        <Link to="/newsfeed">
          <Space>
            <h5 className="b3">News & Blogs</h5>
          </Space>
        </Link>,
        'newsfeed',
        <img src={Newspaper} alt="news" />,
      ),
      data?.role === 'admin'
        ? getItem(
            <Link to="/location">
              <Space>
                <h5 className="b3">Locations</h5>
              </Space>
            </Link>,
            'location',
            <img src={Location} alt="locations" />,
          )
        : null,
      getItem(
        <Link to="/inventory">
          <Space>
            <h5 className="b3">Inventory</h5>
          </Space>
        </Link>,
        'inventory',
        <img src={Inventory} alt="inventory" />,
      ),
      getItem(
        <Link to="/templates">
          <Space>
            <h5 className="b3">Templates</h5>
          </Space>
        </Link>,
        'templates',
        <img src={Bookmark} alt="templates" />,
      ),
      data?.role === 'admin'
        ? getItem(
            <Link to="/activity">
              <Space>
                <h5 className="b3">Activity</h5>
              </Space>
            </Link>,
            'activity',
            <img src={activityIcon} alt="activity" />,
          )
        : null,
    ]),
  ].filter(Boolean)

const getMenuCollapasedItems = (data?: any): MenuItem[] =>
  [
    getItem(
      <Link to="/dashboard">
        <Space size={5}>
          <h5 className="b3">Overview</h5>
        </Space>
      </Link>,
      'dashboard',
      <img src={dashboardIcon} />,
    ),
    getItem(
      <Link to="/analytics">
        <Space size={5}>
          <h5 className="b3">Analytics</h5>
        </Space>
      </Link>,
      'analytics',
      <img src={AnalyticsIcon} alt="analytics" />,
    ),

    data?.role === 'admin'
      ? getItem(
          <Link to="/settings?tab=GeneralSetting">
            <Space size={15}>
              <h5 className="b3">Settings</h5>
            </Space>
          </Link>,
          'settings',
          <SettingOutlined className="text-black" size={20} />,
        )
      : null,

    getItem(
      <Link to="/organization?page=1&limit=10&status=approved">
        <Space size={15}>
          <h5 className="b3">Organizations</h5>
        </Space>
      </Link>,
      'organization',
      <img src={buildings_svg} alt="organization" />,
    ),
    getItem(
      <Link to="/organizer?page=1&limit=10&status=active">
        <Space size={18}>
          <h5 className="b3">Organizer</h5>
        </Space>
      </Link>,
      'organizer',
      <img src={userPlus_svg} alt="organizer" />,
    ),
    getItem(
      <Link to="/teams">
        <Space size={18}>
          <h5 className="b3">Teams</h5>
        </Space>
      </Link>,
      'teams',
      <img src={userPlus_svg} alt="teams" />,
    ),
    getItem(
      <Link to="/mentors">
        <Space size={14}>
          <h5 className="b3">Mentors</h5>
        </Space>
      </Link>,
      'mentors',
      <img src={medal_svg} alt="mentors" />,
    ),
    getItem(
      <Link to="/family">
        <Space size={8}>
          <h5 className="b3">Families</h5>
        </Space>
      </Link>,
      'family',
      <img src={user_svg} alt="family" />,
    ),

    getItem(
      <Link to="/spaces?page=1&limit=10">
        <Space size={18}>
          <h5 className="b3">Spaces</h5>
        </Space>
      </Link>,
      'events',
      <img src={Calendar} alt="events" />,
    ),
    data?.role === 'admin'
      ? getItem(
          <Link to="/jobrequest">
            <Space>
              <h5 className="b3">Request</h5>
            </Space>
          </Link>,
          'jobrequest',
          <img src={work_svg} alt="job request" />,
        )
      : null,
    data?.role === 'admin'
      ? getItem(
          <Link to="/sessions">
            <Space>
              <h5 className="b3">Sessions</h5>
            </Space>
          </Link>,
          'sessions',
          <img src={sessionIcon_svg} alt="sessions" />,
        )
      : null,
    data?.role === 'admin'
      ? getItem(
          <Link to="/jobs">
            <Space>
              <h5 className="b3">Jobs</h5>
            </Space>
          </Link>,
          'jobs',
          <img src={Jobs_svg} alt="jobs" />,
        )
      : null,
    getItem(
      <Link to="/newsfeed">
        <Space>
          <h5 className="b3">News</h5>
        </Space>
      </Link>,
      'newsfeed',
      <img src={Newspaper} alt="news" />,
    ),
    data?.role === 'admin'
      ? getItem(
          <Link to="/location">
            <Space>
              <h5 className="b3">Locations</h5>
            </Space>
          </Link>,
          'location',
          <img src={Location} alt="locations" />,
        )
      : null,
    getItem(
      <Link to="/inventory">
        <Space>
          <h5 className="b3">Inventory</h5>
        </Space>
      </Link>,
      'inventory',
      <img src={Inventory} alt="inventory" />,
    ),
    getItem(
      <Link to="/templates">
        <Space>
          <h5 className="b3">Templates</h5>
        </Space>
      </Link>,
      'templates',
      <img src={Bookmark} alt="templates" />,
    ),
    data?.role === 'admin'
      ? getItem(
          <Link to="/activity">
            <Space>
              <h5 className="b3">Activity</h5>
            </Space>
          </Link>,
          'activity',
          <img src={activityIcon} alt="activity" />,
        )
      : null,
  ].filter(Boolean)

const NewSideBar = () => {
  const history = useHistory()
  const [collapsed, setCollapsed] = useState(false)
  const { isLoading, data } = useQuery(['getMe'], () => getMe())
  const [activeKey, setActiveKey] = useState('dashboard')

  const location = useLocation()

  useEffect(() => {
    const parts = location.pathname.split('/')
    const activeKey = parts.length > 1 ? `${parts[1]}` : '/dashborad'
    // Fix for spaces route - map 'spaces' to 'events' key since menu item key is 'events'
    if (activeKey === 'spaces') {
      setActiveKey('events')
    } else {
      setActiveKey(activeKey)
    }
  }, [location])

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={value => setCollapsed(value)}
      width={collapsed ? '60px' : '278px'}
      className={collapsed ? 'collapsed-sider' : ''}
      collapsedWidth={60}
    >
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '20rem',
          }}
        >
          <Loader />
        </div>
      ) : (
        <Menu
          theme="dark"
          mode="inline"
          inlineCollapsed={collapsed}
          selectedKeys={[activeKey]}
          openKeys={collapsed ? [] : ['people', 'eventsGroup', 'settings']}
          items={collapsed ? getMenuCollapasedItems(data) : getMenuItems(data)}
        />
      )}
    </Sider>
  )
}

export default NewSideBar
